export default 'Arial, Helvetica, sans-serif';
